<template>
  <nav class="navbar">
    <div class="logo-container">
      <router-link to="/">
        <img class="logo" :src="`${publicPath}img/logo.png`" alt="logo">
      </router-link>
    </div>

    <div type="button" class="hamburger" :class="{'active': isMenuOpen}" @click="toggleMenu" aria-label="Toggle menu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="nav-backdrop" :class="{'open': isMenuOpen}" @click="closeMenu"></div>
    
    <div class="nav-links" :class="{'open': isMenuOpen}">
      <router-link class="nav-link" :class="{'current': currentRoute === 'services'}" to="/services" @click="closeMenu">
        {{ text.navbar.services }}
      </router-link>
      <a href="#Contact" class="nav-link" @click="closeMenu">
        {{ text.navbar.contact }}
      </a>
    </div>
  </nav>
</template>

<script>
import { useRoute } from "vue-router";
import { watch } from "vue";
import json from '../../text.json'

export default {
  name: "navBar",

  data() {
    return {
      text: json,
      currentRoute: '',
      publicPath: '/',
      isMenuOpen: false
    }
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  },

  beforeUnmount() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  },

  mounted() {
    const route = useRoute();
    this.currentRoute = route.name;
    watch(() => route.name, (newRoute) => {
      this.currentRoute = newRoute;
    });
  }
}
</script>

<style scoped>

</style>
